import React, { useCallback, useEffect, useRef, useState } from "react";
import DeviceContext from "../../Services/identifyDevice";
import "../../UI/DocumentBrowse/DocumentBrowse.scss";
import Button, {
  SubmitButton,
  TransparentButton,
} from "../../UI/Button/Button";
import "./DocVerificationForm.scss";
import {
  photographCategoryId,
  signatureCategoryId,
  statusUrl,
} from "../../utils/constants";
import {
  AGetDocumentList,
  AGetPendingDocument,
  AGetUploadedDocument,
  AGetDocStatus,
  ADownloadDocument,
  AgetPdf,
  ACheckLocation,
  ACheckPhotoLiveness,
  QCServiceTaskCreation,
} from "../../Services/dashboard/docVerificationAPIServices";
import DocumentBrowse, {
  DocDetailFormat,
} from "../../UI/DocumentBrowse/DocumentBrowse";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import GlobalStore from "../../store/globalStore";
import { AUploadDocument } from "../../Services/dashboard/brokerageServices";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import {
  secondChequeDocumnetId,
  thirdChequeDocumnetId,
  fourthChequeDocumnetId,
  fifthChequeDocumnetId,
  secondBankStatementDocumnetId,
  thirdBankStatementDocumnetId,
  fourthBankStatementDocumnetId,
  fifthBankStatementDocumnetId,
  DIY,
  panDocumentId,
  dashboardUrl,
  geoLocationConfig,
  signatureDocumentId,
  ipvNavBarObj,
} from "../../utils/constants";
import {
  completeModuleStatus,
  incompleteStageNavigation,
} from "../../Services/globalService";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";
import { useNavigate } from "react-router-dom";
import gtmService from "../../Services/gtmService";
import {
  ASaveIPVerificationDetails,
  ASendSmsV2,
} from "../../Services/dashboard/ipvApiServices";
import useGeoLocation from "../../../customHooks/useGeoLocation";
import InfoModal from "../../UI/InfoModal/InfoModal";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import config from "../../../config/domain";
import ViewSignatureSamplePopupDynamic from "./ViewSignatureSamplePopup.Dynamic";

export interface DocVerifcationFormProps {
  UTM_SOURCE: string;
  UTM_MEDIUM?: string;
  UTM_CAMPAIGN?: string;
}

export interface iGeoLocation {
  loaded: boolean;
  coordinates: { lat: string; lng: string };
  error: boolean;
}

export interface uploadDocObj {
  applicationid: string;
  base64document: string;
  filename: string;
  panNo: string;
  ModifiedBy?: string | number;
}

export const initialDocObj: DocDetailFormat = {
  id: "",
  disable: true,
  uploadPer: 0,
  hideProgress: false,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  isWatsappFlag: false,
};
export const initialPhotoDocObj: DocDetailFormat = {
  id: "",
  disable: false,
  uploadPer: 0,
  hideProgress: false,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  isWatsappFlag: false,
};
export const initialPanDocObj: DocDetailFormat = {
  id: "",
  disable: false,
  uploadPer: 0,
  hideProgress: true,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  iscropped: false,
  isWatsappFlag: false,
};

const DocVerifcationFormDynamic: React.FC<DocVerifcationFormProps> = (
  props
) => {
  // const history = useHistory();
  const navigate = useNavigate();
  let userId = "0";
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = tokenMainObj?.UserId?.toString();
  }
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [uploadDocFlag, setUploadDocFlag] = useState<boolean>(false);
  const [uploadVaiWatsAppFlag, setUploadViaWatsAppFlag] =
    useState<boolean>(false);
  const [pendingDocObj, setPendingDocObj] = useState<any>();
  const [photoObj, setPhotoObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [panObj, setPanObj] = useState<DocDetailFormat>({
    ...JSON.parse(JSON.stringify(initialPanDocObj)),
  });
  const [firstBankObj, setFirstBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [secondBankObj, setSecondBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [thirdBankObj, setThirdBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [fourthBankObj, setFourthBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [fifthBankObj, setFifthBankObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });

  const [permSecondAddressObj, setPermSecondAddressObj] =
    useState<DocDetailFormat>({ ...initialPanDocObj });
  const [corrSecondAddressObj, setCorrSecondAddressObj] =
    useState<DocDetailFormat>({ ...initialPanDocObj });
  const [permAddressObj, setPermAddressObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [corrAddressObj, setCorrAddressObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [signatureObj, setSignatureObj] = useState<DocDetailFormat>({
    ...initialPanDocObj,
  });
  const [signaturesArr, setSignaturesArr] = useState<Array<DocDetailFormat>>(
    []
  );
  const [signatureObjSecond, setSignatureObjSecond] = useState<DocDetailFormat>(
    {
      ...initialPanDocObj,
    }
  );
  const [incomeObj, setIncomeObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [errCode, setErrCode] = React.useState<number | string>("");
  const [showRetake, setShowRetake] = useState<boolean>(false);
  const videoRefElement = React.useRef<HTMLVideoElement>(null);
  const canvasRefElement = React.useRef<HTMLCanvasElement>(null);
  const uploadedPhotoRefElement = React.useRef<HTMLTableSectionElement>(null);
  const [mediaRecorder, setMediaRecorder] = React.useState<MediaRecorder>();
  const [turnOfCamera, setTurnOfCamera] = React.useState<MediaStream>();
  const [showVidPerm, setShowVidPerm] = React.useState<boolean>(false);
  const [showSignaturePopup, setShowSignaturePopup] =
    React.useState<boolean>(false);
  const [showPhotoPopup, setShowPhotoPopup] = React.useState<boolean>(false);
  const [showSignatureMobilePopup, setShowSignatureMobilePopup] =
    React.useState<boolean>(false);
  const [showPhotoMobilePopup, setShowPhotoMobilePopup] =
    React.useState<boolean>(false);
  const [autoQc, setAutoQc] = React.useState<boolean>(false);
  const [photoBase64, setPhotoBase64] = React.useState<string>("");
  const [panBase64, setPanBase64] = React.useState<string>("");
  const [bankStage, setBankStage] = React.useState<boolean>(false);
  const [anotherFile, setAnotherFile] = React.useState<boolean>(false);
  const [corrAnotherFile, setCorrAnotherFile] = React.useState<boolean>(false);
  const [panName, setPanName] = React.useState<string>("");
  const [firstBankName, setFirstBankName] = React.useState<string>("");
  const [secondBankName, setSecondBankName] = React.useState<string>("");
  const [thirdBankName, setThirdBankName] = React.useState<string>("");
  const [fourthBankName, setFourthBankName] = React.useState<string>("");
  const [fifthBankName, setFifthBankName] = React.useState<string>("");
  const [togSig, setTogSig] = useState<boolean>(false);
  const [firstBankDetails, setFirstBankDetails] = React.useState<any>("");
  const [secondBankDetails, setSecondBankDetails] = React.useState<any>("");
  const [thirdBankDetails, setThirdBankDetails] = React.useState<any>("");
  const [fourthBankDetails, setFourthBankDetails] = React.useState<any>("");
  const [fifthBankDetails, setFifthBankDetails] = React.useState<any>("");

  const [addressName, setAddressName] = React.useState<string>("");
  const [corrAddressName, setCorrAddressName] = React.useState<string>("");
  const [signatureName, setSignatureName] = React.useState<string>("");
  const [incomeName, setIncomeName] = React.useState<string>("");
  const [isPhotoPendingFlag, setIsPhotoPendingFlag] =
    React.useState<boolean>(false);

  const [isNewPhoto, setIsNewPhoto] = useState<boolean>(false);
  const [isNewPan, setIsNewPan] = useState<boolean>(false);
  const [isNewFirstBank, setIsNewFirstBank] = useState<boolean>(false);
  const [isNewSecondBank, setIsNewSecondBank] = useState<boolean>(false);
  const [isNewThirdBank, setIsNewThirdBank] = useState<boolean>(false);
  const [isNewFourthBank, setIsNewFourthBank] = useState<boolean>(false);
  const [isNewFifthBank, setIsNewFifthBank] = useState<boolean>(false);

  const [isNewPermAddress, setIsNewPermAddress] = useState<boolean>(false);
  const [isNewCorrAddress, setIsNewCorrAddress] = useState<boolean>(false);
  const [isNewSignature, setIsNewSignature] = useState<boolean>(false);
  const [isNewIncome, setIsNewIncome] = useState<boolean>(false);
  const [loaderSign, setLoaderSign] = React.useState<boolean>(false);
  const [showCorr, setShowCorr] = React.useState<boolean>(false);
  const [isPanAndDobMatch, setIsPanAndDobMatch] = useState<boolean>(true);
  const [seedingPopup, setSeedingPopup] = React.useState<boolean>(
    !GlobalStore.isSeeding
  );
  const [regectedDocStatus, setRegectedDocStatus] = React.useState<
    Array<object>
  >([{}]);
  const [aadharAddress, setAadharAddress] = React.useState<boolean>(true);
  const [corrAadharAddress, setCorrAadharAddress] =
    React.useState<boolean>(true);
  const [location, setLocation] = useState<any>("");
  const geoLoc: iGeoLocation = useGeoLocation();
  const [isGeoError, setIsGeoError] = React.useState<boolean>(false);
  const [isGeoErrorTimeFlag, setIsGeoErrorTimeFlag] =
    React.useState<boolean>(false);

  const [removePanImg, setRemovePanImg] = React.useState<boolean>(false);
  const [isManual, setIsManual] = React.useState<boolean>(false);

  let watchPositionId: number;

  //File specific error msg state

  const [panCardError, setPanCardError] = useState<any>("");
  const [firstBankListError, setFirstBankListError] = useState<any>("");
  const [secondBankListError, setSecondBankListError] = useState<any>("");
  const [thirdBankListError, setThirdBankListError] = useState<any>("");
  const [fourthBankListError, setFourthBankListError] = useState<any>("");
  const [fifthBankListError, setFifthBankListError] = useState<any>("");
  const [permAddListError, setPermAddListError] = useState<any>("");
  const [corrAddListError, setCorrAddListError] = useState<any>("");
  const [incomeListError, setIncomeListError] = useState<any>("");
  const [secondDocError, setSecondDocError] = useState<any>("");
  const [corrSecondDocError, setCorrSecondDocError] = useState<any>("");
  const [signatureListError, setSignatureListError] = useState<any>("");
  const [showBrowserPermissionModal, setsShowBrowserPermissionModal] =
    useState<boolean>(false);
  const [isSdkSelfie, setIsSdkSelfie] = useState<boolean>(true);
  const [browserPermission, setBrowserPermission] = useState<boolean>(true);
  const [locationPermission, setLocationPermission] = useState<boolean>(true);
  const [cameraPermission, setCameraPermission] = useState<boolean>(true);
  // To check if a default permanent address is available for the application
  const [defaultPermAddressProof, setDefaultPermAddressProof] = useState(false);
  //permAddButDisable
  const [showSignatureTwoPopup, setShowSignatureTwoPopup] =
    React.useState<boolean>(false);
  const [nomineeFirstObj, setNomineeFirstObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [nomineeSecondObj, setNomineeSecondObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [nomineeThirdObj, setNomineeThirdObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [guardianFirstObj, setGuardianFirstObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [guardianSecondObj, setGuardianSecondObj] = useState<DocDetailFormat[]>(
    [
      {
        ...initialDocObj,
        disable: false,
      },
      { ...initialDocObj, disable: false },
    ]
  );
  const [guardianThirdObj, setGuardianThirdObj] = useState<DocDetailFormat[]>([
    {
      ...initialDocObj,
      disable: false,
    },
    { ...initialDocObj, disable: false },
  ]);
  const [nomineeFirstList, setNomineeFirstList] = useState([]);
  const [nomineeSecondList, setNomineeSecondList] = useState([]);
  const [nomineeThirdList, setNomineeThirdList] = useState([]);
  const [guardianFirstList, setGuardianFirstList] = useState([]);
  const [guardianSecondList, setGuardianSecondList] = useState([]);
  const [guardianThirdList, setGuardianThirdList] = useState([]);
  const [nomineeGuardianTog, setNomineeGuardianTog] = useState({
    nomineeFirst: false,
    nomineeSecond: false,
    nomineeThree: false,
    guardianFirst: false,
    guardianSecond: false,
    guardianThird: false,
  });
  const [nomineeGuardianError, setNomineeGuardianError] = useState({
    nomFirstPhotoId: "",
    nomFirstSignature: "",
    nomSecondPhotoId: "",
    nomSecondSignature: "",
    nomThirdPhotoId: "",
    nomThirdSignature: "",
    guardianFirstPhotoId: "",
    guardianFirstSignature: "",
    guardianSecondPhotoId: "",
    guardianSecondSignature: "",
    guardianThirdPhotoId: "",
    guardianThirdSignature: "",
  });

  const [isNomineeGuardian, setIsNomineeGuardian] = useState({
    isNomFirstPhoto: false,
    isNomFirstSignature: false,
    isNomSecondPhoto: false,
    isNomSecondSignature: false,
    isNomThirdPhoto: false,
    isNomThirdSignature: false,
    isGuardianFirstPhoto: false,
    isGuardianFirstSignature: false,
    isGuardianSecondPhoto: false,
    isGuardianSecondSignature: false,
    isGuardianThirdPhoto: false,
    isGuardianThirdSignature: false,
  });

  const [nomineeDisable, setNomineeDisable] = useState(false);
  const [guardianDisable, setGuardianDisable] = useState(false);
  const [permAddButDisable, setPermAddButDisable] = useState(false);
  const [panButDisable, setPanButDisable] = useState(false);
  const [liveLocationCheck, setLiveLocationCheck] = useState<any>({
    checkPhotoLiveness: false,
    checkLocation: false,
  });
  const [photoErrorMsg, setPhotoErrorMsg] = React.useState("");
  const [clientStageDetails, setClientStageDetails] = React.useState<any>();

  const [blockAadhar, setBlockAadhar] = React.useState(false);
  const [checkLocationCalled, setCheckLocationCalled] =
    React.useState<boolean>(false);
  const [sendSmsLinkModal, setSendSmsLinkModal] =
    React.useState<boolean>(false);
  const [showRemovePopup, setShowRemovePopup] = React.useState<boolean>(false);
  const [sendSmsLinkError, setSendSmsLinkError] = React.useState<string>("");
  const [timer, setTimer] = useState(0);
  const [status, setStatus] = useState("send");
  const [signatureOption, setSignatureOption] = useState("upload");
  const [selectedDocs, setSelectedDocs] = useState<any>([]);
  const [activeSampleDocId, setActiveSampleDocId] = useState<number | null>(
    null
  );
  const [popupPos, setPopupPos] = useState<{
    top: number;
    left: number;
  } | null>(null);

  const intervalRef = useRef<any>(null);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (GlobalStore?.isKRA && GlobalStore?.stageStatus?.accountcategory == 2) {
      setCameraPermission(false);
    }
    if (GlobalStore.location) {
      setLocation(GlobalStore.location);
    } else if (GlobalStore?.stageStatus?.accountcategory !== 2) {
      setTimeout(() => {
        navigator.geolocation.getCurrentPosition(saveLocation, errorLocation, {
          enableHighAccuracy: geoLocationConfig.enableHighAccuracy,
          maximumAge: geoLocationConfig.maximumAge,
          timeout: geoLocationConfig.timeout,
        });
        setIsGeoErrorTimeFlag(true);
      }, geoLocationConfig.errorTimer);
    }

    AGetStageCompletionStatus(getClientStageDetails, GlobalStore.applicationID);
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    GlobalStore.isKRA || clientPartialDetails_ao.isKRA
      ? setBlockAadhar(true)
      : setBlockAadhar(false);
    if (
      GlobalStore?.isKRA &&
      GlobalStore?.stageStatus?.accountcategory == 2 &&
      uploadedPhotoRefElement !== null &&
      uploadedPhotoRefElement.current !== null
    )
      uploadedPhotoRefElement.current!.hidden = true;
    if (GlobalStore.isOTCFlow)
      uploadDoc()
  }, []);

  React.useEffect(() => {
    if (
      panBase64 !== null &&
      panBase64 !== undefined &&
      panBase64 !== "" &&
      (panObj?.imgUrl == "" ||
        panObj?.imgUrl == undefined ||
        panObj?.imgUrl == null)
    ) {
      setPanObj((panObj) => {
        panObj.imgUrl = getbase64(panBase64, panObj);
        return panObj;
      });
    }
  }, [panBase64]);
  React.useEffect(() => {
    if (location && !checkLocationCalled && !isSdkSelfie) {
      GlobalStore.location = location;
      setIsGeoError(false);
      setIsGeoErrorTimeFlag(false);
      // const locationString;
      const locationObj = {
        lat: location.lat,
        lng: location.long,
      };
      ACheckLocation((res: any) => checkLocationRes(res), locationObj);
    }
  }, [location]);

  React.useEffect(() => {
    if (nomineeFirstList.length > 0) {
      let nomineeOne = [...nomineeFirstObj];
      for (let i = 0; i < nomineeOne.length; i++) {
        if (nomineeOne[i].imgUrl === "" || nomineeOne[i].fileName === "") {
          setNomineeDisable(true);
          break;
        } else {
          setNomineeDisable(false);
        }
      }
    }

    if (nomineeSecondList.length > 0) {
      let nomineeTwo = [...nomineeSecondObj];
      for (let i = 0; i < nomineeTwo.length; i++) {
        if (nomineeTwo[i].imgUrl === "" || nomineeTwo[i].fileName === "") {
          setNomineeDisable(true);
          break;
        } else {
          setNomineeDisable(false);
        }
      }
    }
    if (nomineeThirdList.length > 0) {
      let nomineeThree = [...nomineeThirdObj];
      for (let i = 0; i < nomineeThree.length; i++) {
        if (nomineeThree[i].imgUrl === "" || nomineeThree[i].fileName === "") {
          setNomineeDisable(true);
          break;
        } else {
          setNomineeDisable(false);
        }
      }
    }

    if (guardianFirstList.length > 0) {
      let guardianOne = [...guardianFirstObj];
      for (let i = 0; i < guardianOne.length; i++) {
        if (guardianOne[i].imgUrl === "" || guardianOne[i].fileName === "") {
          setGuardianDisable(true);
          break;
        } else {
          setGuardianDisable(false);
        }
      }
    }
    if (guardianSecondList.length > 0) {
      let guardianTwo = [...guardianSecondObj];
      for (let i = 0; i < guardianTwo.length; i++) {
        if (guardianTwo[i].imgUrl === "" || guardianTwo[i].fileName === "") {
          setGuardianDisable(true);
          break;
        } else {
          setGuardianDisable(false);
        }
      }
    }
    if (guardianThirdList.length > 0) {
      let guardianThree = [...guardianThirdObj];
      for (let i = 0; i < guardianThree.length; i++) {
        if (
          guardianThree[i].imgUrl === "" ||
          guardianThree[i].fileName === ""
        ) {
          setGuardianDisable(true);
          break;
        } else {
          setGuardianDisable(false);
        }
      }
    }
  }, [
    nomineeFirstList,
    nomineeSecondList,
    nomineeThirdList,
    guardianFirstList,
    guardianSecondList,
    guardianThirdList,
    nomineeFirstObj,
    nomineeSecondObj,
    nomineeThirdObj,
    guardianFirstObj,
    guardianSecondObj,
    guardianThirdObj,
  ]);

  React.useEffect(() => {
    console.log("UseEffect called");
    if (!isSdkSelfie) {
      watchPositionId = navigator.geolocation.watchPosition(
        successPosition,
        errorPosition
      );
      if (locationPermission === true && cameraPermission === true) {
        console.log("inside setter ");
        setBrowserPermission(true);
        setsShowBrowserPermissionModal(false);
        setIsGeoError(false);
      } else {
        console.log("inside setter else");
        setBrowserPermission(false);
        setsShowBrowserPermissionModal(true);
        setIsGeoError(true);
      }
    }
    getLocation();
  }, [geoLoc, locationPermission, cameraPermission, isSdkSelfie]);

  React.useEffect(() => {
    if (photoObj.imgUrl && !isSdkSelfie) {
      ACheckPhotoLiveness(
        (res: any) => getExtractPhotoLiveness(res),
        photoObj.imgUrl.split(",")[1],
        GlobalStore.leadId
      );
    }
  }, [photoObj, isSdkSelfie]);

  React.useEffect(() => {
    return () => {
      turnOfCamera && turnOfCamera.getVideoTracks()[0].stop();
    };
  }, [turnOfCamera]);

  const getLocation = () => {
    if (geoLoc.loaded && geoLoc.error == false) {
      console.log("I'm here-", geoLoc);
      setLocation({
        lat: geoLoc.coordinates.lat,
        long: geoLoc.coordinates.lng,
      });
    } else if (GlobalStore?.stageStatus?.accountcategory !== 2) {
      if (navigator && navigator.geolocation) {
        console.log("I'm here in else-", navigator);
        navigator.geolocation.getCurrentPosition(saveLocation, errorLocation, {
          enableHighAccuracy: geoLocationConfig.enableHighAccuracy,
          maximumAge: geoLocationConfig.maximumAge,
          timeout: geoLocationConfig.timeout,
        });
        navigator.geolocation.getCurrentPosition(saveLocation);
        watchPositionId = navigator.geolocation.watchPosition(
          successPosition,
          errorPosition
        );
      } else {
        alert("Geo location is not supported by this browser");
      }
    }
  };

  const errorLocation = (err: any) => {
    if (!location && !GlobalStore.location) {
      console.log(location, "errorLoaction function log");
      console.log(`ERROR(${err.code}): ${err.message}`);
      geoLoc.error = true;
    }
  };

  const saveLocation = (position: { coords: any }) => {
    watchPositionId = navigator.geolocation.watchPosition(
      successPosition,
      errorPosition
    );
    // setLocation(`${position.coords.latitude}, ${position.coords.longitude}`);
    setLocation({
      lat: position.coords.latitude,
      long: position.coords.longitude,
    });
    GlobalStore.location = {
      lat: position.coords.latitude,
      long: position.coords.longitude,
    };
    geoLoc.coordinates.lat = position.coords.latitude;
    geoLoc.coordinates.lng = position.coords.longitude;
    geoLoc.error = false;
    setIsGeoError(false);
    setIsGeoErrorTimeFlag(false);
    setIsLoading(false);
    console.log("In saveLocation", geoLoc);
    // GlobalStore.location = location;
  };

  function successPosition(data: any) {
    console.log("successPosition");
    setIsLoading(false);
    setLocationPermission(true);
    setLocation({
      lat: data.coords.latitude,
      long: data.coords.longitude,
    });
    navigator.geolocation.clearWatch(watchPositionId);
  }

  function errorPosition(data: any) {
    console.log("errorPosition");
    setIsLoading(true);
    setLocationPermission(false);
  }
  const checkLocationRes = (res: any) => {
    if (!res || res.error) {
      console.log("LIVE", res);
      if (errCode !== res.error) setErrCode(errCode ? errCode : "" + res.error);
      setIsLoading(false);
      setLiveLocationCheck({
        ...liveLocationCheck,
        checkLocation: true,
      });
      gtmService({ action: "CheckLocation", label: "ERROR || ERR999" });
    } else {
      setCheckLocationCalled(true);
      if (res.data && res.data.LocationInIndia) {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: false,
        });
      } else if (!res.data.LocationInIndia) {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkLocation: true,
        });
        if (errCode !== res.data.Message)
          setErrCode(errCode ? errCode : "" + res.data.Message);
      }
      setIsLoading(false);
    }
  };
  function getClientStageDetails(res: any) {
    if (!res || res.error) {
      //   setErrCode("106- Failed to fetch stage completion data.");
      setErrCode(errCode + res.error);
      gtmService({
        action: "GetStageCompletionStatus",
        label: "ERROR || ERR141",
      });
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        if (responseObj?.elog_opted) {
          setSignatureOption("elog");
          setTimeout(() => {
            let signatureCopy = { ...initialPanDocObj };
            signatureCopy.documentcategory = "Signature";
            signatureCopy.documentCategoryId = "27";
            signatureCopy.documentId = 305;
            signatureCopy.isElogSignOpted = true;
            signatureCopy.imgUrl = "";
            setSignatureObj(signatureCopy);
          }, 1000);
        }
        setClientStageDetails(responseObj);
        if (GlobalStore.isKRA || responseObj.iskra) {
          permAddressObj.disable = true;
          setPermAddressObj(permAddressObj);
          setBlockAadhar(true);
        } else {
          setBlockAadhar(false);
        }
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isKYC = responseObj.iskyc;
        clientPartialDetails_ao.isKRA = responseObj.iskra;

        setIsManual(clientPartialDetails_ao.isManual);
        clientPartialDetails_ao.isDigiLocker =
          responseObj.isdigilockercompleted;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        if (responseObj.isbankdetailscompleted) {
          setBankStage(true);
        } else {
          setBankStage(false);
        }

        if (responseObj.ispanlinkedwithaadhar === true) {
          GlobalStore.isSeeding = true;
          setSeedingPopup(false);
        } else if (responseObj.ispanlinkedwithaadhar === false) {
          GlobalStore.isSeeding = false;
          setSeedingPopup(true);
        }
      } else {
        gtmService({
          action: "GetStageCompletionStatus",
          label: "ERROR || ERR141-S",
        });
      }
    }
    AGetPendingDocument(getPendingDoc, GlobalStore.applicationID); //1
  }

  function showPhotoPreview(showPhotoPreview: boolean) {
    videoRefElement.current!.hidden = showPhotoPreview;
    canvasRefElement.current!.hidden = !showPhotoPreview;
  }
  function sendSmsLink() {
    setSendSmsLinkError("");
    let AccountObj = {
      PanNo: GlobalStore?.personaldetails?.pan,
      AccountCategory: GlobalStore?.accountcategory
        ? GlobalStore?.accountcategory
        : GlobalStore?.stageStatus?.accountcategory,
      userid: userId,
    };
    let accountObjString = JSON.stringify(AccountObj);
    const encodedPan = btoa(accountObjString);
    const stringParams = `ipvLink?id=${encodedPan}`;
    const ipvUrl = `${config.root}${stringParams}`;

    console.log(ipvUrl);
    const smsBody = {
      applicationId: GlobalStore.applicationID,
      accountCategory: GlobalStore?.accountcategory,
      // selfieLinkText: `Give a Smile and complete your IPV process for Online Account Opening, click here ${ipvUrl} to complete the process. Regards, Nuvama`,
    };
    ASendSmsV2((res: any) => {
      if (!res.error) {
        setSendSmsLinkModal(true);
        setTimer(59);
        setStatus("countdown");
      } else {
        setSendSmsLinkError(res.error);
        setStatus("send");
      }
    }, smsBody);
  }

  useEffect(() => {
    if (timer > 0) {
      intervalRef.current = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(intervalRef.current);
            setStatus("resend");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [timer]);

  async function turnOnCamera() {
    getLocation();
    const constraints = {
      audio: false,
      video: {
        facingMode: "user",
      },
    };

    function handleSuccess(turnOfCamera: MediaStream) {
      setCameraPermission(true);
      setIsLoading(false);
      videoRefElement.current!.srcObject = turnOfCamera;
      setMediaRecorder(new MediaRecorder(turnOfCamera));
      setTurnOfCamera(turnOfCamera);
      setShowVidPerm(false);
    }

    function handleError(error: any) {
      setIsLoading(true);
      setCameraPermission(false);
      setShowVidPerm(true);
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(handleSuccess)
      .catch(handleError);
  }

  const getDocumentStatus = (res: any) => {
    if (!res || res.error) {
      // setErrCode("164- Failed to get the document status for the application.");
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR125" });
    } else {
      if (res.data) {
        const regectedDoc = JSON.parse(res.data).filter(
          (item: any) => item.Status === "Rejected"
        );
        setRegectedDocStatus(regectedDoc);
      } else {
        gtmService({
          action: "GetDocumentDetails",
          label: "ERROR || ERR125-S",
        });
      }
    }
  };

  const downloadDocAndReturnBase64 = (
    fileName: string,
    docItem: any
  ): Promise<string> => {
    return new Promise((resolve) => {
      ADownloadDocument(
        (res: any) => {
          if (!res || res.error) {
            gtmService({
              action: "DownloadDocumentFromS3",
              label: "ERROR || ERR128",
            });
            resolve("");
          } else if (res.data) {
            const base64 = getbase64(res.data.base64document, docItem);
            resolve(base64);
          } else {
            gtmService({
              action: "DownloadDocumentFromS3",
              label: "ERROR || ERR128-S",
            });
            resolve("");
          }
        },
        fileName,
        docItem.UploadedDocPath
      );
    });
  };

  const getDocList = async (res: any, selectDocTemp: any) => {
    if (!res || res.error) {
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR121" });
      return;
    }

    if (!res.data) {
      gtmService({
        action: "GetDocumentDetails",
        label: "ERROR || ERR121-S",
      });
      return;
    }

    let listObj = res.data ? JSON.parse(res.data) : [];

    const finalDocs = selectDocTemp.map((selDoc: any) => {
      const matches = listObj.filter(
        (item: any) => item.DocumentCategoryId === selDoc.DocumentCategoryId
      );

      return matches.length > 0
        ? { ...selDoc, DocumentDetails: matches }
        : selDoc;
    });

    const finalDocsUpdated = await Promise.all(
      finalDocs.map(async (selDoc: any) => {
        // If NO fileName → return object as is
        if (!selDoc.FileName) {
          return { ...selDoc };
        }

        // If fileName exists → download + append keys
        const imgUrl = await downloadDocAndReturnBase64(
          selDoc.FileName,
          selDoc
        );
        const viewLink = `${selDoc.UploadedDocPath}/${selDoc.FileName}`;

        // Generate ID : ApplicationId + DocumentName (no space)
        const cleanDocName = (selDoc.DocumentName || "").replace(/\s+/g, "");
        const idKey = `${selDoc.ApplicationId}_${cleanDocName}`;
        return {
          ...selDoc,
          id: String(selDoc.DocumentId || selDoc.DocumentCategoryId),
          disable: false,
          isImageOnly: true,
          uploadPer: 100,
          hideProgress: false,
          fileName: idKey,
          showFile: false,
          mimeType: selDoc.MimeType,
          imgUrl,
          documentCategory: selDoc.DocumentCategory || "",
          viewLink,
        };
      })
    );

    console.log("FINAL OUTPUT:", finalDocsUpdated);

    setSelectedDocs(finalDocsUpdated);
  };

  const popularSignatures = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    "/9j/": "image/jpg",
    Qk02U: "image/bmp",
  };

  function detectMimeType(base64 = "") {
    for (const [signature, type] of Object.entries(popularSignatures)) {
      if (base64.startsWith(signature)) {
        return type;
      }
    }
    return undefined; // Explicitly return undefined if no match is found
  }

  function getbase64(dataString: string, obj: DocDetailFormat) {
    if (obj.mimeType === "" || obj.mimeType == ".") {
      let mimeType = detectMimeType(dataString);
      return "data:" + mimeType + ";base64," + dataString;
    } else {
      return (
        "data:" +
        (obj.mimeType === "application/pdf"
          ? "application/pdf"
          : "image/jpeg") +
        ";base64," +
        dataString
      );
    }
  }

  const getUploadedDoc = (res: any, penDoc: any) => {
    // debugger
    if (!res || res.error) {
      setErrCode(errCode + res.error);
      gtmService({
        action: "GetDocumentDetails",
        label: "ERROR || ERR124",
      });
      return;
    }

    const uplDoc = JSON.parse(res.data);
    const formattedPendingDocs = Array.isArray(penDoc)
      ? penDoc.map((doc: any) => ({
        ...doc,
        uploaded: false,
        disable: false,
        uploadPer: 0,
        showFile: true,
        hideProgress: false,
        imgUrl: "",
      }))
      : [];

    const safeUploadedDocs = Array.isArray(uplDoc) ? uplDoc : [];

    const selectDocTemp = [...formattedPendingDocs, ...safeUploadedDocs];

    console.log("penDocpenDoc", penDoc, uplDoc, selectDocTemp);

    AGetDocumentList(
      (res: any) => getDocList(res, selectDocTemp),
      GlobalStore.applicationID
    ); //2
  };

  // useEffect(() => {
  //   if (selectedDocs?.length > 0) {
  //     window.localStorage.setItem(
  //       "selectedDocsCache",
  //       JSON.stringify(selectedDocs)
  //     );
  //   }
  // }, [selectedDocs]);

  useEffect(() => {
    console.log("ccccccccccccccccc----dusra", selectedDocs);
  }, [selectedDocs]);

  const getPendingDoc = (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR122" });
    } else {
      // if (res.data) {
      const penDoc = JSON.parse(res.data);
      //    AGetDocumentList(getDocList, GlobalStore.applicationID); //2
      AGetUploadedDocument(
        (res: any) => getUploadedDoc(res, penDoc),
        GlobalStore.applicationID
      ); //4
      AGetDocStatus(getDocumentStatus, GlobalStore.applicationID); //3
    }
  };

  const getscreenShotURL = async (blob: Blob) => {
    const new_File = new File([blob as BlobPart], "personalPhoto.jpeg", {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
    if (new_File.size > 50000000) {
      alert("video size exceeds maximum limit. Please upload it again");
      return false;
    }
    if (new_File.size < 1000) {
      alert("video size should be greater than 1KB. Please upload it again");
      return false;
    }
    const fileReader = new FileReader();
    fileReader.onload = function (e) {
      let base64 = (e.target && e.target.result)?.toString();
      photoObj.imgUrl = "";
      setPhotoObj(photoObj);
      setPhotoBase64(base64!.split(",")[1]);
      if (base64?.toString()) {
        const modifiedBy = window.sessionStorage.getItem("empCode");
        let uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: base64!.split(",")[1],
          filename: new_File.name,
          panNo: GlobalStore?.personaldetails.pan,
          ModifiedBy: modifiedBy && modifiedBy != "" ? modifiedBy : 0,
        };
        setIsLoading(true);
        setLoaderSign(true);

        ACheckPhotoLiveness(
          (res: any) => getExtractPhotoLiveness(res),
          base64!.split(",")[1],
          GlobalStore.leadId
        );
        AUploadDocument(
          (res: any) => getFetchResponse(res, new_File.name),
          uploadObj
        );
        const ipvObj = {
          leadid: GlobalStore.leadId,
          clientprimarydetailid: GlobalStore.clientPrimaryDetailId,
          applicationid: GlobalStore.applicationID,
          placeofDeclaration: "mumbai",
          empName: "diy user",
          designation: "online rm",
          branch: "mumbai",
          empCode: "0",
          organization: "Nuvama Wealth & investment Ltd",
          organizationCode: "2",
          // geo_location: location,
          latitude: location.lat,
          longitude: location.long,
          ipaddress: "192.168.200.80",
          source: "DocVerification",
          createdBy: parseInt(userId),
        };
        ASaveIPVerificationDetails(
          (res: any) => iPVerificationSaved(res, ipvObj),
          ipvObj
        );
      }
    };
    fileReader.readAsDataURL(new_File);
  };

  const capturePhoto = () => {
    if (
      location !== "" &&
      location !== undefined &&
      location.lat !== "" &&
      location.lat !== undefined &&
      location.long !== "" &&
      location.long !== undefined
    ) {
      setIsLoading(true);
      setIsNewPhoto(true);
      setShowRetake(true);
      showPhotoPreview(true);
      let canvasPic: HTMLCanvasElement = document.getElementById(
        "capture"
      ) as HTMLCanvasElement;
      let videoPic: HTMLVideoElement = document.getElementById(
        "videoPersonal"
      ) as HTMLVideoElement;
      captureScreenShot(canvasPic, videoPic, getscreenShotURL);
      turnOfCamera && turnOfCamera.getVideoTracks()[0].stop();
    } else {
      setBrowserPermission(true);
    }
  };

  function captureScreenShot(
    canvas: HTMLCanvasElement,
    video: HTMLVideoElement,
    callback: CallableFunction
  ) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas
      .getContext("2d")!
      .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    canvas.toBlob((blob) => {
      callback(blob);
    });
  }

  const iPVerificationSaved = async (res: any, ipvObj: any) => {
    console.log("CALLEDDDDD");
    if (!res || res.error) {
      //setErrCode('Error in saving geo-location details');
      //setIsLoading(false);
      setErrCode(errCode + res.error);
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR143",
      });
      setIsLoading(false);
    } else {
      setIsLoading(false);
      setLoaderSign(false);
      gtmService({
        action: "SaveIpverificationDetails",
        label: "ERROR || ERR143-S",
      });
    }
  };
  const showGuideText = (idObj: any) => {
    let showText: boolean = false;
    if (
      idObj?.DocumentCategoryId == photographCategoryId ||
      idObj?.DocumentCategoryId == signatureCategoryId
    ) {
      showText = true;
    }
    return showText;
  };
  const setSamplePopupups = (idObj: any) => {
    if (idObj?.DocumentCategoryId == signatureCategoryId) {
      setShowPhotoPopup(false);
      setShowPhotoMobilePopup(false);
      if (DeviceContext()?.isMobile) {
        setShowSignatureMobilePopup(true);
      } else setShowSignaturePopup(true);
    } else if (idObj?.DocumentCategoryId == photographCategoryId) {
      setShowSignaturePopup(false);
      setShowSignatureMobilePopup(false);
      if (DeviceContext()?.isMobile) {
        setShowPhotoMobilePopup(true);
      } else setShowPhotoPopup(true);
    }
  };
  const getExtractPhotoLiveness = (res: any) => {
    if (!res || res.error) {
      // setErrCode("116 - Error in fetching Pan details from our system.");
      // setErrCode(errorMessage.panDetailsFailed);
      if (errCode !== res.error) setErrCode(errCode ? errCode : "" + res.error);
      setPhotoErrorMsg("");
      setLoaderSign(false);
      setLiveLocationCheck({
        ...liveLocationCheck,
        checkPhotoLiveness: true,
      });
      setIsLoading(false);
      gtmService({ action: "checkPhotoLiveness", label: "ERROR || ERR998" });
    } else {
      if (res.data && res.data.IsLive) {
        setPhotoErrorMsg(res.data.Message);
        liveLocationCheck.checkPhotoLiveness = false;
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkPhotoLiveness: false,
        });
      } else if (!res.data.IsLive) {
        setLiveLocationCheck({
          ...liveLocationCheck,
          checkPhotoLiveness: true,
        });
        console.log("res.data.Message", res.data.Message);
        setPhotoErrorMsg(res.data.Message);
        // if (errCode !== res.data.Message)
        //   setErrCode(errCode ? errCode : "" + res.data.Message);
      }
      setIsLoading(false);
      setLoaderSign(false);
    }
  };

  const getFetchResponse = (res: any, fileName: string) => {
    if (!res || res.error) {
      // setErrCode("1361- Error in uploading the file.");
      setErrCode(errCode + res.error);
      gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR139" });
      setIsLoading(false);
    } else {
      if (res.data) {
        console.log("getFetchResponse", res.data);
        setIsLoading(false);
        // photoObj.fileName = res.data.Guid;
        // photoObj.mimeType = res.data.Guid.split(".")[1];
        if (photoBase64 !== undefined && panBase64 !== undefined) {
          // setErrCode(errCode);
        }
      } else {
        setErrCode(errCode + res.error);
        gtmService({
          action: "UploadDocumentToS3",
          label: "ERROR || ERR139-S",
        });
      }
    }
  };

  function getMimeType(base64String?: string) {
    // Split the string to get the metadata part before the comma
    if (base64String !== null && base64String !== undefined) {
      const mimeType = base64String.match(/^data:([^;]+);base64,/);
      return mimeType ? mimeType[1] : ".";
    }
    return ".";
  }

  const getPDFData = (res: any) => {
    if (!res || res.error) {
      // setErrCode(137);
      setErrCode(errCode + res.error);
      gtmService({
        action: "MargeMultipleImagestoPDF",
        label: "ERROR || ERR136",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        setAddressName(res.data.Guid);
        permAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        setIsLoading(false);
        // if (permAddressObj.documentId === aadhaarDocumnetId) {
        //   setIsLoading(true);
        //   AextractAadhaar(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === passportDocumnetId) {
        //   setIsLoading(true);
        //   AextractPassport(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === voterIdDocumentId) {
        //   setIsLoading(true);
        //   AextractVoterid(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === dlDocumentId) {
        //   setIsLoading(true);
        //   AextractDl((res: any) => storeOcrData(res, addressOCR), addressOCR);
        // }
      } else {
        gtmService({
          action: "MargeMultipleImagestoPDF",
          label: "ERROR || ERR136-S",
        });
      }
    }
  };

  const getCorrPDFData = (res: any) => {
    if (!res || res.error) {
      // setErrCode(137);
      setErrCode(errCode + res.error);
      gtmService({
        action: "MargeMultipleImagestoPDF",
        label: "ERROR || ERR137",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        setCorrAddressName(res.data.Guid);
        corrAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: corrAddressObj.documentcategory,
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        // if (corrAddressObj.documentId === corrAadhaarDocumnetId) {
        //   setIsLoading(true);
        //   AextractAadhaar(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrPassportDocumnetId) {
        //   setIsLoading(true);
        //   AextractPassport(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
        //   setIsLoading(true);
        //   AextractVoterid(
        //     (res: any) => storeOcrData(res, addressOCR),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrDlDocumentId) {
        //   setIsLoading(true);
        //   AextractDl((res: any) => storeOcrData(res, addressOCR), addressOCR);
        // }
      } else {
        gtmService({
          action: "MargeMultipleImagestoPDF",
          label: "ERROR || ERR137-S",
        });
      }
    }
  };

  function handErrorForFileUpload(id: string, res: any) {
    if (id === "firstBankDoc") {
      setFirstBankListError(res.error);
    }
    if (id === "secondBankDoc") {
      setSecondBankListError(res.error);
    }
    if (id === "thirdBankDoc") {
      setThirdBankListError(res.error);
    }
    if (id === "fourthBankDoc") {
      setFourthBankListError(res.error);
    }
    if (id === "fifthBankDoc") {
      setFifthBankListError(res.error);
    }
    if (id === "permAddress") {
      setPermAddListError(res.error);
    }
    if (id === "corrAddress") {
      setCorrAddListError(res.error);
    }
    if (id === "signature") {
      setSignatureListError(res.error);
    }
    if (id === "incomeDoc") {
      setIncomeListError(res.error);
    }
    if (id === "permSecondAddress") {
      setSecondDocError(res.error);
    }
    if (id === "corrSecondAddress") {
      setCorrSecondDocError(res.error);
    }

    if (id === "nomFirstPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomFirstPhotoId: res.error,
      });
    }
    if (id === "nomFirstSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomFirstSignature: res.error,
      });
    }
    if (id === "nomSecondPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomSecondPhotoId: res.error,
      });
    }
    if (id === "nomSecondSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomSecondSignature: res.error,
      });
    }
    if (id === "nomThirdPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomThirdPhotoId: res.error,
      });
    }
    if (id === "nomThirdSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        nomThirdSignature: res.error,
      });
    }
    if (id === "guardianFirstPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianFirstPhotoId: res.error,
      });
    }
    if (id === "guardianFirstSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianFirstSignature: res.error,
      });
    }
    if (id === "guardianSecondPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianSecondPhotoId: res.error,
      });
    }
    if (id === "guardianSecondSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianSecondSignature: res.error,
      });
    }
    if (id === "guardianThirdPhotoId") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianThirdPhotoId: res.error,
      });
    }
    if (id === "guardianThirdSignature") {
      setNomineeGuardianError({
        ...nomineeGuardianError,
        guardianThirdSignature: res.error,
      });
    }
  }
  const getUploadRes = (res: any, id: string, val: any, fileName: string, docCatObj: any) => {
    if (!res || res.error) {
      gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });
      setIsLoading(false);
      // setErrCode("1361- Error in uploading the file.");\
      handErrorForFileUpload(id, res);
      if (
        !res?.errorCode?.includes("C11BE292") &&
        !res?.errorCode?.includes("C11BE422")
      ) {
        setErrCode(errCode + res.error);
      }
    } else {
      if (res.data) {
        setSelectedDocs((prevDocs: any) =>
          prevDocs.map((doc: any) => {
            if (
              doc.DocumentCategoryId === docCatObj.DocumentCategoryId ||
              doc.id === docCatObj.id
            ) {
              return {
                ...doc,
                fileName: fileName,
                disable: false,
                isImageOnly: true,
                uploadPer: 100,
                hideProgress: false,
                showFile: false,
                imgUrl: val,
              };
            }
            return doc;
          })
        );

      } else {
        setErrCode(errCode + res.error);
        gtmService({
          action: "UploadDocumentToS3",
          label: "ERROR || ERR140-S",
        });
      }
    }
  };

  const onUploadProgress = (
    event: ProgressEvent,
    id: string,
    fileName: string,
    type: string
  ) => {
    const { loaded, total } = event;
    let percentage = Math.floor((loaded * 100) / total);
    let panCopy = { ...panObj };
    let firstBankCopy = { ...firstBankObj };
    let secondBankCopy = { ...secondBankObj };
    let thirdBankCopy = { ...thirdBankObj };
    let fourthBankCopy = { ...fourthBankObj };
    let fifthBankCopy = { ...fifthBankObj };
    let permAddressCopy = { ...permAddressObj };
    let permSecondAddressCopy = { ...permSecondAddressObj };
    let corrAddressCopy = { ...corrAddressObj };
    let corrSecondAddressCopy = { ...corrSecondAddressObj };
    let signatureCopy = { ...signatureObj };
    let signatureArrCopy = [...signaturesArr];
    let incomeCopy = { ...incomeObj };
    let nomineeOneCopy = [...nomineeFirstObj];
    let nomineeTwoCopy = [...nomineeSecondObj];
    let nomineeThreeCopy = [...nomineeThirdObj];
    let GuardianOneCopy = [...guardianFirstObj];
    let GuardianTwoCopy = [...guardianSecondObj];
    let GuardianThreeCopy = [...guardianThirdObj];

    if (percentage < 100) {
      if (id === "panCard") {
        panCopy.id = id;
        panCopy.disable = false;
        panCopy.uploadPer = percentage;
        panCopy.hideProgress = true;
        panCopy.showFile = false;
        setPanObj(panCopy);
      } else if (id === "firstBankDoc") {
        firstBankCopy.id = id;
        firstBankCopy.disable = false;
        firstBankCopy.uploadPer = percentage;
        firstBankCopy.hideProgress = true;
        firstBankCopy.showFile = false;
        setFirstBankObj(firstBankCopy);
      } else if (id === "secondBankDoc") {
        secondBankCopy.id = id;
        secondBankCopy.disable = false;
        secondBankCopy.uploadPer = percentage;
        secondBankCopy.hideProgress = true;
        secondBankCopy.showFile = false;
        setSecondBankObj(secondBankCopy);
      } else if (id === "thirdBankDoc") {
        thirdBankCopy.id = id;
        thirdBankCopy.disable = false;
        thirdBankCopy.uploadPer = percentage;
        thirdBankCopy.hideProgress = true;
        thirdBankCopy.showFile = false;
        setThirdBankObj(thirdBankCopy);
      } else if (id === "fourthBankDoc") {
        fourthBankCopy.id = id;
        fourthBankCopy.disable = false;
        fourthBankCopy.uploadPer = percentage;
        fourthBankCopy.hideProgress = true;
        fourthBankCopy.showFile = false;
        setFourthBankObj(fourthBankCopy);
      } else if (id === "fifthBankDoc") {
        fifthBankCopy.id = id;
        fifthBankCopy.disable = false;
        fifthBankCopy.uploadPer = percentage;
        fifthBankCopy.hideProgress = true;
        fifthBankCopy.showFile = false;
        setFifthBankObj(fifthBankCopy);
      } else if (id === "permAddress") {
        permAddressCopy.id = id;
        permAddressCopy.disable = false;
        permAddressCopy.uploadPer = percentage;
        permAddressCopy.hideProgress = true;
        permAddressCopy.showFile = false;
        setPermAddressObj(permAddressCopy);
      } else if (id === "permSecondAddress") {
        permSecondAddressCopy.id = id;
        permSecondAddressCopy.disable = false;
        permSecondAddressCopy.uploadPer = percentage;
        permSecondAddressCopy.hideProgress = true;
        permSecondAddressCopy.showFile = false;
        setPermSecondAddressObj(permSecondAddressCopy);
      } else if (id === "corrAddress") {
        corrAddressCopy.id = id;
        corrAddressCopy.disable = false;
        corrAddressCopy.uploadPer = percentage;
        corrAddressCopy.hideProgress = true;
        corrAddressCopy.showFile = false;
        setCorrAddressObj(corrAddressCopy);
      } else if (id === "corrSecondAddress") {
        corrSecondAddressCopy.id = id;
        corrSecondAddressCopy.disable = false;
        corrSecondAddressCopy.uploadPer = percentage;
        corrSecondAddressCopy.hideProgress = true;
        corrSecondAddressCopy.showFile = false;
        setCorrSecondAddressObj(corrSecondAddressCopy);
      } else if (id === "signature") {
        signatureCopy.id = id;
        signatureCopy.disable = false;
        signatureCopy.uploadPer = percentage;
        signatureCopy.hideProgress = true;
        signatureCopy.showFile = false;
        setSignatureObj({ ...signatureCopy });
      } else if (id.includes("signature_")) {
        let signObj = signatureArrCopy.find(
          (a) => a.documentCategoryId == id.split("_")[1]
        );
        if (signObj) {
          signObj.id = id;
          signObj.disable = false;
          signObj.uploadPer = percentage;
          signObj.showFile = false;
          signObj.hideProgress = false;
          signObj.mimeType = type;
          signObj.fileName = fileName;
          const index = signatureArrCopy.findIndex(
            (a) => a.documentCategoryId == id.split("_")[1]
          );
          let tempArr = signatureArrCopy;
          if (index !== -1) {
            tempArr[index] = signObj;
          }
          setSignaturesArr(tempArr);
        }
      } else if (id === "incomeDoc") {
        incomeCopy.id = id;
        incomeCopy.disable = false;
        incomeCopy.uploadPer = percentage;
        incomeCopy.hideProgress = true;
        incomeCopy.showFile = false;
        setIncomeObj(incomeCopy);
      } else if (id === "nomFirstPhotoId") {
        nomineeOneCopy[0].disable = false;
        nomineeOneCopy[0].uploadPer = percentage;
        nomineeOneCopy[0].hideProgress = true;
        nomineeOneCopy[0].showFile = false;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomFirstSignature") {
        nomineeOneCopy[1].disable = false;
        nomineeOneCopy[1].uploadPer = percentage;
        nomineeOneCopy[1].hideProgress = true;
        nomineeOneCopy[1].showFile = false;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomSecondPhotoId") {
        nomineeTwoCopy[0].disable = false;
        nomineeTwoCopy[0].uploadPer = percentage;
        nomineeTwoCopy[0].hideProgress = true;
        nomineeTwoCopy[0].showFile = false;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomSecondSignature") {
        nomineeTwoCopy[1].disable = false;
        nomineeTwoCopy[1].uploadPer = percentage;
        nomineeTwoCopy[1].hideProgress = true;
        nomineeTwoCopy[1].showFile = false;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomThirdPhotoId") {
        nomineeThreeCopy[0].disable = false;
        nomineeThreeCopy[0].uploadPer = percentage;
        nomineeThreeCopy[0].hideProgress = true;
        nomineeThreeCopy[0].showFile = false;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "nomThirdSignature") {
        nomineeThreeCopy[1].disable = false;
        nomineeThreeCopy[1].uploadPer = percentage;
        nomineeThreeCopy[1].hideProgress = true;
        nomineeThreeCopy[1].showFile = false;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "guardianFirstPhotoId") {
        GuardianOneCopy[0].disable = false;
        GuardianOneCopy[0].uploadPer = percentage;
        GuardianOneCopy[0].hideProgress = true;
        GuardianOneCopy[0].showFile = false;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianFirstSignature") {
        GuardianOneCopy[1].disable = false;
        GuardianOneCopy[1].uploadPer = percentage;
        GuardianOneCopy[1].hideProgress = true;
        GuardianOneCopy[1].showFile = false;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianSecondPhotoId") {
        GuardianTwoCopy[0].disable = false;
        GuardianTwoCopy[0].uploadPer = percentage;
        GuardianTwoCopy[0].hideProgress = true;
        GuardianTwoCopy[0].showFile = false;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianSecondSignature") {
        GuardianTwoCopy[1].disable = false;
        GuardianTwoCopy[1].uploadPer = percentage;
        GuardianTwoCopy[1].hideProgress = true;
        GuardianTwoCopy[1].showFile = false;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianThirdPhotoId") {
        GuardianThreeCopy[0].disable = false;
        GuardianThreeCopy[0].uploadPer = percentage;
        GuardianThreeCopy[0].hideProgress = true;
        GuardianThreeCopy[0].showFile = false;
        setGuardianThirdObj(GuardianThreeCopy);
      } else if (id === "guardianThirdSignature") {
        GuardianThreeCopy[1].disable = false;
        GuardianThreeCopy[1].uploadPer = percentage;
        GuardianThreeCopy[1].hideProgress = true;
        GuardianThreeCopy[1].showFile = false;
        setGuardianThirdObj(GuardianThreeCopy);
      }
    } else if (percentage === 100) {
      if (id === "panCard") {
        panCopy.id = id;
        panCopy.disable = false;
        panCopy.uploadPer = percentage;
        panCopy.showFile = false;
        panCopy.hideProgress = false;
        panCopy.fileName = fileName;
        panCopy.mimeType = type;
        setPanObj(panCopy);
      } else if (id === "firstBankDoc") {
        firstBankCopy.id = id;
        firstBankCopy.disable = false;
        firstBankCopy.uploadPer = percentage;
        firstBankCopy.fileName = fileName;
        firstBankCopy.showFile = false;
        firstBankCopy.hideProgress = false;
        firstBankCopy.mimeType = type;
        setFirstBankObj(firstBankCopy);
      } else if (id === "secondBankDoc") {
        secondBankCopy.id = id;
        secondBankCopy.disable = false;
        secondBankCopy.uploadPer = percentage;
        secondBankCopy.fileName = fileName;
        secondBankCopy.showFile = false;
        secondBankCopy.hideProgress = false;
        secondBankCopy.mimeType = type;
        setSecondBankObj(secondBankCopy);
      } else if (id === "thirdBankDoc") {
        thirdBankCopy.id = id;
        thirdBankCopy.disable = false;
        thirdBankCopy.uploadPer = percentage;
        thirdBankCopy.fileName = fileName;
        thirdBankCopy.showFile = false;
        thirdBankCopy.hideProgress = false;
        thirdBankCopy.mimeType = type;
        setThirdBankObj(thirdBankCopy);
      } else if (id === "fourthBankDoc") {
        fourthBankCopy.id = id;
        fourthBankCopy.disable = false;
        fourthBankCopy.uploadPer = percentage;
        fourthBankCopy.fileName = fileName;
        fourthBankCopy.showFile = false;
        fourthBankCopy.hideProgress = false;
        fourthBankCopy.mimeType = type;
        setFourthBankObj(fourthBankCopy);
      } else if (id === "fifthBankDoc") {
        fifthBankCopy.id = id;
        fifthBankCopy.disable = false;
        fifthBankCopy.uploadPer = percentage;
        fifthBankCopy.fileName = fileName;
        fifthBankCopy.showFile = false;
        fifthBankCopy.hideProgress = false;
        fifthBankCopy.mimeType = type;
        setFifthBankObj(fifthBankCopy);
      } else if (id === "permAddress") {
        permAddressCopy.id = id;
        permAddressCopy.disable = false;
        permAddressCopy.uploadPer = percentage;
        permAddressCopy.showFile = false;
        permAddressCopy.hideProgress = false;
        permAddressCopy.mimeType = type;
        permAddressCopy.fileName = fileName;
        setPermAddressObj(permAddressCopy);
      } else if (id === "permSecondAddress") {
        permSecondAddressCopy.id = id;
        permSecondAddressCopy.disable = false;
        permSecondAddressCopy.uploadPer = percentage;
        permSecondAddressCopy.showFile = false;
        permSecondAddressCopy.hideProgress = false;
        permSecondAddressCopy.mimeType = type;
        permSecondAddressCopy.fileName = fileName;
        setPermSecondAddressObj(permSecondAddressCopy);
      } else if (id === "corrAddress") {
        corrAddressCopy.id = id;
        corrAddressCopy.disable = false;
        corrAddressCopy.uploadPer = percentage;
        corrAddressCopy.showFile = false;
        corrAddressCopy.hideProgress = false;
        corrAddressCopy.mimeType = type;
        corrAddressCopy.fileName = fileName;
        setCorrAddressObj(corrAddressCopy);
      } else if (id === "corrSecondAddress") {
        corrSecondAddressCopy.id = id;
        corrSecondAddressCopy.disable = false;
        corrSecondAddressCopy.uploadPer = percentage;
        corrSecondAddressCopy.showFile = false;
        corrSecondAddressCopy.hideProgress = false;
        corrSecondAddressCopy.mimeType = type;
        corrSecondAddressCopy.fileName = fileName;
        setCorrSecondAddressObj(corrSecondAddressCopy);
      } else if (id === "signature") {
        signatureCopy.id = id;
        signatureCopy.disable = false;
        signatureCopy.uploadPer = percentage;
        signatureCopy.showFile = false;
        signatureCopy.hideProgress = false;
        signatureCopy.mimeType = type;
        signatureCopy.fileName = fileName;
        setSignatureObj(signatureCopy);
      } else if (id.includes("signature_")) {
        let signObj = signatureArrCopy.find(
          (a) => a.documentCategoryId == id.split("_")[1]
        );
        if (signObj) {
          signObj.id = id;
          signObj.disable = false;
          signObj.uploadPer = percentage;
          signObj.showFile = false;
          signObj.hideProgress = false;
          signObj.mimeType = type;
          signObj.fileName = fileName;
          const index = signatureArrCopy.findIndex(
            (a) => a.documentCategoryId == id.split("_")[1]
          );
          let tempArr = signatureArrCopy;
          if (index !== -1) {
            tempArr[index] = signObj;
          }
          setSignaturesArr(tempArr);
        }
      } else if (id === "incomeDoc") {
        incomeCopy.id = id;
        incomeCopy.disable = false;
        incomeCopy.uploadPer = percentage;
        incomeCopy.showFile = false;
        incomeCopy.hideProgress = false;
        incomeCopy.mimeType = type;
        incomeCopy.fileName = fileName;
        setIncomeObj(incomeCopy);
      } else if (id === "nomFirstPhotoId") {
        nomineeOneCopy[0].disable = false;
        nomineeOneCopy[0].uploadPer = percentage;
        nomineeOneCopy[0].showFile = false;
        nomineeOneCopy[0].hideProgress = false;
        nomineeOneCopy[0].mimeType = type;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomFirstSignature") {
        nomineeOneCopy[1].disable = false;
        nomineeOneCopy[1].uploadPer = percentage;
        nomineeOneCopy[1].showFile = false;
        nomineeOneCopy[1].hideProgress = false;
        nomineeOneCopy[1].mimeType = type;
        setNomineeFirstObj(nomineeOneCopy);
      } else if (id === "nomSecondPhotoId") {
        nomineeTwoCopy[0].disable = false;
        nomineeTwoCopy[0].uploadPer = percentage;
        nomineeTwoCopy[0].showFile = false;
        nomineeTwoCopy[0].hideProgress = false;
        nomineeTwoCopy[0].mimeType = type;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomSecondSignature") {
        nomineeTwoCopy[1].disable = false;
        nomineeTwoCopy[1].uploadPer = percentage;
        nomineeTwoCopy[1].showFile = false;
        nomineeTwoCopy[1].hideProgress = false;
        nomineeTwoCopy[1].mimeType = type;
        setNomineeSecondObj(nomineeTwoCopy);
      } else if (id === "nomThirdPhotoId") {
        nomineeThreeCopy[0].disable = false;
        nomineeThreeCopy[0].uploadPer = percentage;
        nomineeThreeCopy[0].showFile = false;
        nomineeThreeCopy[0].hideProgress = false;
        nomineeThreeCopy[0].mimeType = type;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "nomThirdSignature") {
        nomineeThreeCopy[1].disable = false;
        nomineeThreeCopy[1].uploadPer = percentage;
        nomineeThreeCopy[1].showFile = false;
        nomineeThreeCopy[1].hideProgress = false;
        nomineeThreeCopy[1].mimeType = type;
        setNomineeThirdObj(nomineeThreeCopy);
      } else if (id === "guardianFirstPhotoId") {
        GuardianOneCopy[0].disable = false;
        GuardianOneCopy[0].uploadPer = percentage;
        GuardianOneCopy[0].showFile = false;
        GuardianOneCopy[0].hideProgress = false;
        GuardianOneCopy[0].mimeType = type;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianFirstSignature") {
        GuardianOneCopy[1].disable = false;
        GuardianOneCopy[1].uploadPer = percentage;
        GuardianOneCopy[1].showFile = false;
        GuardianOneCopy[1].hideProgress = false;
        GuardianOneCopy[1].mimeType = type;
        setGuardianFirstObj(GuardianOneCopy);
      } else if (id === "guardianSecondPhotoId") {
        GuardianTwoCopy[0].disable = false;
        GuardianTwoCopy[0].uploadPer = percentage;
        GuardianTwoCopy[0].showFile = false;
        GuardianTwoCopy[0].hideProgress = false;
        GuardianTwoCopy[0].mimeType = type;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianSecondSignature") {
        GuardianTwoCopy[1].disable = false;
        GuardianTwoCopy[1].uploadPer = percentage;
        GuardianTwoCopy[1].showFile = false;
        GuardianTwoCopy[1].hideProgress = false;
        GuardianTwoCopy[1].mimeType = type;
        setGuardianSecondObj(GuardianTwoCopy);
      } else if (id === "guardianThirdPhotoId") {
        GuardianThreeCopy[0].disable = false;
        GuardianThreeCopy[0].uploadPer = percentage;
        GuardianThreeCopy[0].showFile = false;
        GuardianThreeCopy[0].hideProgress = false;
        GuardianThreeCopy[0].mimeType = type;
        setGuardianThirdObj(GuardianThreeCopy);
      } else if (id === "guardianThirdSignature") {
        GuardianThreeCopy[1].disable = false;
        GuardianThreeCopy[1].uploadPer = percentage;
        GuardianThreeCopy[1].showFile = false;
        GuardianThreeCopy[1].hideProgress = false;
        GuardianThreeCopy[1].mimeType = type;
        setGuardianThirdObj(GuardianThreeCopy);
      }
    }
  };

  const uploadDoc = () => {
    gtmService({
      action: "DOCUMENT_VERIFICATION",
      label: "DOCUMENT_UPLOAD | UPLOAD",
    });
    setUploadDocFlag(true);
    setUploadViaWatsAppFlag(false);
    getLocation();
  };

  function onSignatureUploadCompleteElog(
    val: any,
    fileName: string,
    id: string,
    type: string,
    isElogSignOpted: boolean = false
  ) {
    const modifiedBy = window.sessionStorage.getItem('empCode')
    let uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val!.split(",")[1],
      panNo: GlobalStore?.personaldetails.pan,
      filename: `${GlobalStore.applicationID}_Signature.${type!.split("/")[1]
        }`,
      DocType: "1",
      QltyByPassFlag: "0",
      ModifiedBy: modifiedBy && modifiedBy != '' ? modifiedBy : 0
    };
    let saveDetails = [];
    let saveSignatureObj = {
      documentCategoryId: signatureObj.documentCategoryId?.toString() || '27',
      documentId: signatureObj.documentId ? signatureObj.documentId?.toString() : '305',
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: signatureObj.isWatsappFlag,
      personaldetailsid: "0",
      autoqc: false,
      isElogSignOpted: isElogSignOpted
    };
    saveDetails.push(saveSignatureObj);
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDetails,
      leadId: GlobalStore.leadId,
      // objUTM_Info: objUTM_Info,
    };
    AUploadDocument(
      (res: any) => { },
      uploadObj,
      (event: ProgressEvent) => { },
      saveObj
    );
  }

  const handleSubmit = () => {
    setLoaderSign(true);
    setIsLoading(true);
    if (
      clientStageDetails.accountcategory == 2 &&
      clientStageDetails.rmassisted
    ) {
      QCServiceTaskCreation(
        (res: any) => {
          if (!res || res.error) {
            setIsLoading(false);
            setErrCode(res.error);
            setLoaderSign(false);
          } else {
            if (
              res &&
              res.data !== null &&
              Object.keys(res?.data)?.length > 0
            ) {
              navigate(statusUrl.docVerificationInProgress);
            } else {
              setErrCode("Something went wrong. please try again later.");
              setIsLoading(false);
              setLoaderSign(false);
            }
          }
        },
        GlobalStore?.applicationID,
        GlobalStore.stageStatus.accountcategory
          ? GlobalStore?.stageStatus?.accountcategory
          : 0
      );
    } else getSaveStatusNew();
  };


  const checkFilledForm = useCallback(() => {
    const hasEmptyFile = selectedDocs?.some((doc: any) => {
      const file = doc?.fileName
      return !file;
    });

    return hasEmptyFile;
  }, [selectedDocs]);

  const getSaveStatusNew = () => {
    AGetPendingDocument((res: any) => {
      if (!res || res.error) {
        setErrCode(errCode + res.error);
        gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR123" });
        setIsLoading(false);
        setLoaderSign(false);
      } else {
        const responseObj = res?.data ? JSON.parse(res?.data) : [];
        if (true) {
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          const onlyIpvPending: Array<any> = (responseObj ?? []).filter(
            (item: any) =>
              item.Mandatory === true &&
              item.DocumentCategory !== "In Person Verification"
          );

          if (onlyIpvPending?.length == 0) {
            setLoaderSign(false);
            if (
              GlobalStore.isDigiLocker ||
              clientPartialDetails_ao.isDigiLocker ||
              GlobalStore.isKRA ||
              clientPartialDetails_ao.isKRA
            ) {
              gtmService({
                action: "DOCUMENT_VERIFICATION",
                label: "Step_Complete",
              });
              completeModuleStatus(dashboardUrl.doc);
              // history.push(incompleteStageNavigation(dashboardUrl.doc));
              navigate(incompleteStageNavigation(dashboardUrl.doc));
            } else {
              const onlyIpvPending: Array<any> = responseObj.filter(
                (item: any) =>
                  //   item.documentcategoryid !== 36 &&
                  //   item.documentcategoryid !== 30 &&
                  // //   item.documentcategoryid !== 62
                  // item.DocumentCategoryId !== 36 &&
                  // item.DocumentCategoryId !== 30 &&
                  // item.DocumentCategoryId !== 62
                  item.Mandatory === true
              );
              if (onlyIpvPending.length === 0) {
                gtmService({
                  action: "DOCUMENT_VERIFICATION",
                  label: "Step_Complete",
                });
              } else if (onlyIpvPending.length > 0) {
                let isIpvExist = GlobalStore.leftNavBarState.filter(
                  (data: any) => data.navUrl === "/ipv"
                );
                if (isIpvExist.length === 0) {
                  GlobalStore.leftNavBarState.push(ipvNavBarObj);
                }
              }
              completeModuleStatus(dashboardUrl.doc);
              // history.push(incompleteStageNavigation(dashboardUrl.doc));
              navigate(incompleteStageNavigation(dashboardUrl.doc));
            }
          } else {
            setErrCode("Please upload all required documents.");
            setIsLoading(false);
            setLoaderSign(false);
          }
        } else {
        }
      }
    }, GlobalStore.applicationID);
  };

  function updateSelectedDocs(categoryId: any, selectedOption: any) {
    setSelectedDocs((prev: any) =>
      prev.map((item: any) =>
        item.DocumentCategoryId === categoryId
          ? { ...item, selectedDoc: selectedOption }
          : item
      )
    );
  }

  function onCommonDocUpload(
    val: any,
    fileName: any,
    docCatObj: any,
    id: any,
    type: any
  ) {
    const selectedDocument = docCatObj?.selectedDoc
      ? docCatObj?.selectedDoc
      : docCatObj?.DocumentDetails
        ? docCatObj.DocumentDetails[0]
        : docCatObj;

    const uploadObj = {
      applicationid: GlobalStore.applicationID,
      base64document: val.split(",")[1],
      filename: fileName,
      panNo: GlobalStore.personaldetails.pan,
      ModifiedBy: sessionStorage.getItem("empCode") || 0,
    };

    const docInfo = {
      documentCategoryId: docCatObj?.DocumentCategoryId?.toString(),
      documentId: selectedDocument?.DocumentId?.toString() || selectedDocument?.toString(),
      documentexpirydate: "",
      fileName: fileName,
      isfilecropped: true,
      mimeType: getMimeType(val),
      panno: GlobalStore.personaldetails.pan,
      isWatsappFlag: false,
      personaldetailsid: "0",
      autoqc: false,
    };

    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: [docInfo],
      leadId: GlobalStore.leadId,
    };

    AUploadDocument(
      (res: any) => getUploadRes(res, id, val, fileName, docCatObj),
      uploadObj,
      (event: any) => onUploadProgress(event, id, fileName, type),
      saveObj
    );
  }

  const getUISamplePopups = (addressProodID: any) => {
    return (
      <ViewSignatureSamplePopupDynamic
        showPopup
        setShowPopup={() => setActiveSampleDocId(null)}
        parentClassName="dynamic-popup"
        position={popupPos}
      />
    );
  };
  return (
    <div>
      <div className="mgt40">
        <div className="fieldLblRight">
          <div className="explain">
            {showBrowserPermissionModal && (
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <InfoModal width={DeviceContext().isMobile ? "328px" : "354px"}>
                  <div className="explainInfo w-100">
                    <label>
                      To open your account online, we would mandatorily need
                      access to your geo locations and camera. In your browser
                      notification, click on 'Allow' to proceed ahead
                    </label>
                  </div>
                  <div>
                    <Button
                      btnName="OK"
                      onClick={() => {
                        turnOnCamera();
                        // setsShowBrowserPermissionModal(false);
                      }}
                    />
                    {/* OK
                    </Button> */}
                  </div>
                </InfoModal>
              </div>
            )}
          </div>
          {sendSmsLinkModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2 className="modal-title">SMS Sent</h2>
                <p className="modal-text">
                  We have sent an SMS to {GlobalStore.user.mobile}
                  <br />
                  with a link for selfie verification.
                </p>
                <div className="modal-actions">
                  <button
                    className="modal-button"
                    onClick={() => setSendSmsLinkModal(false)}
                  >
                    Got it
                  </button>
                </div>
              </div>
            </div>
          )}
          {showRemovePopup && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2 className="modal-title">Alert</h2>
                <p className="modal-text">
                  This action will redirect you to the personal documents page.
                </p>
                <div className="modal-actions">
                  <button
                    className="modal-button"
                    onClick={() => {
                      setShowRemovePopup(false);
                      // history.push(dashboardUrl.personalIfo);
                      if(!GlobalStore.isOTCFlow)
                      navigate(dashboardUrl.personalIfo);
                    }}
                  >
                    Got it
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={"docForm frame" + (isLoading ? " op05" : "")}>
        <fieldset disabled={isLoading}>
          {regectedDocStatus &&
            regectedDocStatus.map(function (item: any, index: number) {
              return (
                <div key={index} className="mrt20">
                  {" "}
                  {item.DocumentType === "PHOTOGRAPH" && (
                    <ErrMsg>
                      <>
                        <label>
                          Reason for Rejection: {item?.RejectionReason}
                        </label>
                      </>
                    </ErrMsg>
                  )}
                </div>
              );
            })}

          {uploadDocFlag ? (
            <>
              <div className="uploadLayout">
                {selectedDocs?.map((docCat: any) => {
                  console.log("docobbbbb", docCat);

                  return (
                    <div key={docCat.DocumentCategoryId}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Title */}
                        <label className="bankDoc">
                          {docCat.DocumentCategory}
                        </label>
                        {docCat.DocumentCategory.includes('Signature') && (
                          <div className="row">
                            <span className="signature-sample">
                              <label
                                className="view-sample"
                                onClick={(e) => {
                                  const rect =
                                    e.currentTarget.getBoundingClientRect();
                                  setPopupPos({
                                    top: rect.top + window.scrollY,
                                    left: 26,
                                  });
                                  setActiveSampleDocId(
                                    docCat.DocumentCategoryId
                                  );
                                }}
                              >
                                View Guidelines
                              </label>
                            </span>
                          </div>
                        )}
                      </div>
                      {activeSampleDocId == docCat.DocumentCategoryId &&
                        getUISamplePopups(docCat)}

                      {/* MULTIPLE OPTIONS → DROPDOWN */}
                      {docCat.DocumentDetails?.length > 1 ? (
                        <DropdownSearch
                          name={`doc_${docCat.DocumentCategoryId}`}
                          searchLength={0}
                          options={docCat.DocumentDetails}
                          searchKey="DocumentName"
                          placeholder={`Select ${docCat.DocumentCategory}`}
                          isDownArrow={true}
                          defaultValue={
                            docCat?.DocumentDetails?.find((e: any) => e.DocumentId == docCat.selectedDoc)?.DocumentName ||
                            docCat?.DocumentName
                          }
                          onOptionSelect={(docId) => {
                            const selected = docCat.DocumentDetails.find(
                              (d: any) => d.DocumentId === docId?.DocumentId
                            );
                            updateSelectedDocs(
                              docCat.DocumentCategoryId,
                              selected?.DocumentId
                            );
                          }}
                        />
                      ) : (
                        <></>
                      )}
                      <label className="bankDocSubHeading mrt10">
                        Upload {docCat.DocumentCategory} document
                      </label>
                      {docCat.DocumentCategory.includes('Signature') &&
                        <div className="signature-container-doc">
                          {!signatureObj?.uploadPer && (
                            <div className="option-row">
                              <input
                                type="radio"
                                name="signatureOption"
                                value="upload"
                                checked={signatureOption === "upload"}
                                onChange={(e) => setSignatureOption(e.target.value)}
                              />
                              <span className="option-label">Upload Signature</span>
                              <span className="recommended">Recommended</span>
                            </div>
                          )}
                          {/* <div className="option-row">
                            <input
                              type="radio"
                              name="signatureOption"
                              value="elog"
                              checked={signatureOption === "elog"}
                              onChange={(e) => {
                                setSignatureOption("elog")
                                let signatureCopy = { ...initialPanDocObj };
                                signatureCopy.documentcategory = "Signature";
                                signatureCopy.documentCategoryId = "27";
                                signatureCopy.documentId = 305;
                                signatureCopy.isElogSignOpted = true;
                                setSignatureObj(signatureCopy);
                                onSignatureUploadCompleteElog(
                                  "",
                                  "",
                                  "signature",
                                  "image/jpeg",
                                  true
                                );
                              }}
                            />
                            <div>
                              <span className="option-label">E-Log (Authentication via BSE STAR MF)</span>
                              {signatureOption === "elog" && (
                                <div className="subtext">Fast and seamless authentication with OTP.</div>
                              )}
                            </div>
                          </div> */}
                        </div>
                      }
                      {((!docCat.DocumentCategory.includes('Signature')) || (docCat.DocumentCategory.includes('Signature') && signatureOption === "upload")) &&
                        <div className="mrt20">
                          <DocumentBrowse
                            id={`doc_${docCat.DocumentCategoryId}`}
                            previewImageexternalClassName="maxSizewithAnother"
                            docObj={docCat}
                            onDocUploadComplete={(val, fileName, id, type) =>
                              onCommonDocUpload(val, fileName, docCat, id, type)
                            }
                            isRemove={(obj: any) => {
                              setSelectedDocs((prevDocs: any) =>
                                prevDocs.map((doc: any) => {
                                  // Match using DocumentCategoryId or id
                                  if (
                                    doc.DocumentCategoryId === obj.DocumentCategoryId ||
                                    doc.id === obj.id
                                  ) {
                                    return {
                                      ...doc,
                                      disable: false,
                                      uploadPer: 0,
                                      hideProgress: true,
                                      showFile: true,
                                      fileName: "",
                                      FileName: ""
                                    };
                                  }
                                  return doc;
                                })
                              );
                            }}
                          // disableRemove={[4, 5, 6, 12].includes(docCat?.DocumentCategoryId)}
                          />
                        </div>
                      }
                      {regectedDocStatus?.map((item: any) => {
                        return (
                          <div className="mrt20" key={item.DocumentId}>
                            {item.DocumentCategory?.toLowerCase() ===
                              docCat.DocumentCategory?.toLowerCase() && (
                                <ErrMsg>
                                  <label>
                                    Reason for Rejection: {item.RejectionReason}
                                  </label>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}

                      <div
                        className="recDiv"
                        style={{ marginBottom: "40px" }}
                      ></div>
                    </div>
                  );
                })}

                {GlobalStore?.stageStatus?.accountcategory == 2 &&
                  GlobalStore?.stageStatus?.rmassisted && (
                    <label className="photoNoteHeading">
                      I hereby confirm that I have personally met with the
                      client and/or visited the client's place and have carried
                      out the due diligence on the documents provided during the
                      onboarding process
                    </label>
                  )}

                {errCode && panButDisable == false && (
                  <div className="errMsgBlck errWidth mrt40">
                    <ErrMsg>
                      {typeof errCode === "number" ? (
                        <>
                          <label>We are facing some technical issue.</label>
                          <label>
                            Please try after sometime (error code:{errCode})
                          </label>
                        </>
                      ) : (
                        <label>{errCode}</label>
                      )}
                    </ErrMsg>
                  </div>
                )}
                <div className="docSubBtn">
                  <SubmitButton
                    isLoading={loaderSign || isLoading}
                    btnName="Submit"
                    onClick={handleSubmit}
                    disabled={
                      // (typeof errCode === "string" && errCode != "") ||
                      // shouldDisable() ||
                      // signatureListError ||
                      checkFilledForm() ||
                      permAddButDisable ||
                      panButDisable ||
                      // || nomineeDisable ||
                      // guardianDisable
                      liveLocationCheck.checkPhotoLiveness
                      // ||
                      // liveLocationCheck.checkLocation
                    }
                  />
                </div>
              </div>
            </>
          ) : (
            <div
              className={DeviceContext().isMobile ? "mrt40" : "selectOption"}
            >
              <label className="heading">Document Upload</label>
              <label className="uploadSubHeading">
                You need to upload your documents for verification. How would
                you like to share the required documents listed below?
              </label>
              <ul className="mrl-25 mrt20 list">
                {pendingDocObj &&
                  pendingDocObj.map((item: any, index: number) => {
                    return (
                      <li
                        key={index}
                        className={`${showGuideText(item) ? "text-family" : ""}`}
                      >
                        {item.DocumentCategory}
                        {showGuideText(item) ? (
                          <label
                            className="view-sample"
                            onClick={() => {
                              setSamplePopupups(item);
                            }}
                          >
                            View Sample
                          </label>
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  })}
              </ul>
              <div className="btnContainer mrt40">
                <div className="borderBlue">
                  <TransparentButton
                    btnName="Upload Now"
                    onClick={() => uploadDoc()}
                    isUpload={true}
                  />
                </div>
              </div>
            </div>
          )}
        </fieldset>
      </div>
    </div>
  );
};

export default DocVerifcationFormDynamic;
